import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import shallow from 'zustand/shallow';

import { getProductVoucherEligibilityList } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export const PRODUCT_VOUCHER_COUNT_KEY = 'ProductVoucherCount';

interface UseProductVoucherCountParams {
  itemCode?: number;
  enabled?: boolean;
}

export const useProductVoucherCount = ({
  itemCode,
  enabled = true,
}: UseProductVoucherCountParams) => {
  const accessToken = useAuthStore((state) => state.access_token);
  const warehouse = useShipToStore((state) => state.selectedShipToId, shallow);

  const normalizedItemCode = useMemo(() => Number(itemCode ?? 0), [itemCode]);

  return useQuery({
    queryKey: [PRODUCT_VOUCHER_COUNT_KEY, warehouse, normalizedItemCode],
    queryFn: async () => {
      if (!accessToken || !warehouse) {
        throw new Error('Missing auth token or warehouse');
      }

      const response = await getProductVoucherEligibilityList(accessToken, {
        item_code: normalizedItemCode,
        warehouse,
        page: 1,
        size: 1,
      });

      return response.pagination.rows;
    },
    enabled:
      enabled &&
      Boolean(accessToken) &&
      Boolean(warehouse) &&
      normalizedItemCode > 0,
    staleTime: 60 * 1000,
    retry: 1,
  });
};
